<script>
    import rpcjs from 'rpcjs';
    const {goto} = rpcjs.props;
    let whiteDiv;
    import {onMount} from 'svelte';
    /**
     */
    function onStart() {
        whiteDiv.style.left = '-100vw';
    }
    onMount(onMountFunction);
    /**
     */
    function startAni() {
        line = 'line2';
        linee = 'linee2';
    }
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
        setTimeout(startAni, 1000);
    }
    let line = 'line';
    let linee = 'line';
    /**
 * Adds two numbers together.
 * @param {int} e The first number.
 */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            goto('/solution');
        }
        if (e.key == 'ArrowLeft') {
            goto('/');
        }
    }

</script>

<svelte:window on:keyup={keycheck}/>
<section>
    <div class="whiteDiv" bind:this={whiteDiv} />

    <div
        class="sectionMain"
        role="presentation"
        on:click={() => {
            goto('/solution');
        }}
    >
        <div class="bakImg">
            <img
                src="/images/problem/bg1.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="miainDiv">
            <div class="graph1">
                <div class="discription">
                    <p>
                        The <span style="font-weight:700;"
                            >value proposition</span
                        > (and success) of a video game franchise is directly proportional
                        to its scale
                    </p>
                </div>
                <div class="innerdiv">
                    <div class="scaleheading">
                        <p>Value Proposition</p>
                    </div>
                    <div>
                        <div class="borderimg">
                            <img
                                src="/images/problem/graph1.svg"
                                alt=""
                                width="100%"
                                height="100%"
                            />
                            <img
                                src="images/problem/Lines1.svg"
                                alt=""
                                class={line}
                            />
                        </div>
                        <div class="bottomHeading">
                            <p>Enagagement - Immersion - Utility</p>
                        </div>
                    </div>
                    <div class="subheading headposition1">
                        <p>
                            128 <span>sq / miles</span> <br /> 18+<span
                                >years</span
                            > <br /> 5M+ <span>players</span>
                        </p>
                    </div>
                    <div class="subheading headposition2">
                        <p>
                            Multiplanetary <br /> 18+<span> years </span>
                            <br />15M+<span> players </span>
                        </p>
                    </div>
                    <div class="subheading headposition3">
                        <p>
                            84<span> sq / miles </span> <br /> 7+
                            <span>years </span> <br /> 40M+<span>
                                players
                            </span>
                        </p>
                    </div>
                    <div class="subheading headposition4">
                        <p>
                            84<span> sq / miles </span> <br /> 7+
                            <span>years </span> <br /> 40M+<span>
                                players
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="graph1">
                <div class="discription">
                    <p>
                        The <span style="font-weight:700;">time</span> and
                        <span style="font-weight:700;">cost</span> of building a
                        large scale video game is exponentially proportional to its
                        scale
                    </p>
                </div>
                <div class="innerdiv">
                    <div class="scaleheading scnd">
                        <p>TIME</p>
                    </div>
                    <div>
                        <div
                            class="borderimg"
                            style="width:29.9vw !important;"
                        >
                            <img
                                src="/images/problem/graph2.svg"
                                alt=""
                                width="100%"
                                height="100%"
                            />
                            <img
                                src="images/problem/Lines.svg"
                                alt=""
                                class={linee}
                            />
                        </div>
                        <div class="bottomHeading">
                            <p>COST</p>
                        </div>
                    </div>
                    <div class="subheading headposition5">
                        <p>9Y</p>
                    </div>
                    <div class="subheading headposition6">
                        <p>5Y</p>
                    </div>
                    <div class="subheading headposition7">
                        <p>3.5Y</p>
                    </div>
                    <div class="subheading headposition8">
                        <p>Unreleased</p>
                    </div>
                    <div class="subheading headposition9">
                        <p>$63M</p>
                    </div>
                    <div class="subheading headposition10">
                        <p>$81M</p>
                    </div>
                    <div class="subheading headposition11">
                        <p>$200M+</p>
                    </div>
                    <div class="subheading headposition12">
                        <p>$316M+</p>
                    </div>
                    <div class="subheading headposition13">
                        <p>$500M+</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pinkdiv">
        <div class="textdiv">
            <p class="text1">GameFi is enabling new games to grow.</p>
            <p class="text2">new forms of interactivity & incentives.</p>
            <p class="text3">
                The quality and depth of games offering GameFi is lacking,
                causing more
                <br />
                serious gamers and gaming influencers to shrug them off as non-games.
            </p>
        </div>
    </div>
</section>

<style>
    section {
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        position: relative;
        font-family: "Montserrat";
    }
    .sectionMain {
        width: 100%;
        height: 100vh;
        position: relative;
        background-color: #101428;
        overflow: hidden;
    }
    .whiteDiv {
        position: absolute;
        background-color: white;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        top: 0;
        left: 0vw;
        z-index: 4;
        transition-duration: 0.6s;
    }
    .bakImg {
        width: 100%;
        position: absolute;
    }
    .miainDiv {
        /* height: min(38.906vw, 69.167vh); */
        position: relative;
        display: flex;
        /* padding: 7.964vh 20.372vh 0; */
        /* justify-content: space-between; */
        gap: 13.542vw;
        left: 14.271vw;
        top: 8vh;
    }
    .borderimg {
        width: 29.063vw;
        margin-top: 1.389vh;
    }
    p {
        margin: 0;
    }
    .graph1 {
        position: relative;
        height: min(36.185vw, 60.107vh);
    }
    .discription {
        width: 23.698vw;
        font-weight: 400;
        font-size: 1.25vw;
        line-height: 1.5vw;
        color: #ffffff;
        margin-left: 3.021vw;
        height: 4.6vw;
    }
    .innerdiv {
        display: flex;
        position: relative;
    }
    .scaleheading {
        font-weight: 900;
    font-size: 1.042vw;
    line-height: 1.25vw;
    text-transform: uppercase;
    color: #ffffff;
    position: absolute;
    left: -7.5vw;
    top: 17.2vw;
    height: 1.25vw;
    transform: rotate(-90deg);
}
    
    .scnd {
        position: absolute;
        left: -2.5vw;
        top: 21.5vw;
    }
    .bottomHeading {
        height: 1.25vw;
        font-weight: 900;
        font-size: 1.042vw;
        line-height: 1.25vw,;
        text-transform: uppercase;
        color: #ffffff;
        text-align: end;
    }
    .subheading {
        height: 2.5vw;
        font-weight: 600;
        font-size: 0.625vw;
        line-height: 0.809vw;
        text-align: right;
        color: #ffffff;
        position: absolute;
        left: 1.51vw;
    }
    .subheading span {
        font-weight: 300;
    }
    .headposition1 {
        right: 0;
        top: 4.583vw;
    }
    .headposition2 {
        left: 19.948vw;
        top: 10.729vw;
    }
    .headposition3 {
        left: 14.427vw;
        top: 14.792vw;
    }
    .headposition4 {
        left: 5.781vw;
        top: 17.656vw;
    }
    .headposition5 {
        top: 3vw;
    }
    .headposition6 {
        top: 10.3vw;
    }
    .headposition7 {
        top: 15vw;
    }
    .headposition8 {
        top: 20.3vw;
    }
    .headposition9 {
        left: 6.25vw;
        bottom: 2.5vw;
    }
    .headposition10 {
        left: 10.417vw;
        bottom: 2.5vw;
    }
    .headposition11 {
        left: 16.25vw;
        bottom: 2.5vw;
    }
    .headposition12 {
        left: 21.563vw;
        bottom: 2.5vw;
    }
    .headposition13 {
        bottom: 2.5vw;
        right: 0;
    }
    .line {
        display: none;
    }
    .line2 {
        width: 25.75vw;
        position: absolute;
        top: 2vw;
        left: 0vw;
        display: block;
    }
    .linee2 {
        width: 26.5vw;
        position: absolute;
        top: 3vw;
        left: 0vw;
        display: block;
    }
    .pinkdiv {
        position: absolute;
        width: 100%;
        height: 30.833vh;
        top: 75vh;
        background-color: #ff007f;
    }
    .textdiv {
        width: 76.354vw;
        position: absolute;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: end;
        top: 2vh;
    }
    .text1 {
        font-size: min(3.125vw, 5.556vh);
        color: #101428;
        font-weight: 900;
        line-height: min(3.438vw, 6.111vh);
    }
    .text2 {
        font-size: min(2.083vw, 3.704vh);
        color: #101428;
        font-weight: 700;
    }
    .text3 {
        font-size: min(1.563vw, 2.778vh);
        line-height: min(1.875vw, 3.333vh);
        color: #101428;
        font-weight: 700;
        margin-top: 1.875vw;
    }
</style>
